import {useState, useEffect, type MutableRefObject} from 'react'

export const useCurrentVisibleHeading = (options: {ref: MutableRefObject<HTMLDivElement | null>}) => {
  const [currVisibleHeading, setCurrVisibleHeading] = useState<string | undefined>()

  useEffect(() => {
    if (options.ref.current === null) {
      return
    }

    const observer = new IntersectionObserver(
      entries => {
        const intersecting = entries.find(entry => entry.isIntersecting)

        if (intersecting === undefined || typeof intersecting.target.id !== 'string') {
          return
        }

        setCurrVisibleHeading(intersecting.target.id)
      },
      {threshold: 0.75},
    )

    /**
     * Get all h2 headings in the scope of the ref, which should be the content container.
     * Only observing h2 elements because the TOC only renders h2 headings. If we observe
     * h3/h4 elements, the active heading can become an h3/h4 id that doesn't exist in the
     * TOC, causing the TOC to lose its active highlighting when scrolling through subheadings.
     */
    const headings = Array.from(options.ref.current.querySelectorAll(':scope h2[id]'))

    for (const heading of headings) {
      observer.observe(heading)
    }

    return () => observer.disconnect()
  }, [options.ref])

  return currVisibleHeading
}
